import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { MstRemarks } from 'src/common/interfaces';
import { getMstRemarks } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const remarksOptions = [
  { value: 1, label: '支払条件' },
  { value: 2, label: '有効期限' },
  { value: 3, label: '納入予定日' },
  { value: 4, label: '保守契約条件' },
];

const ModalGuideRemarks = ({
  setIsOpen,
  onCallbackFunction,
  mstRemarksKbValue,
}: {
  setIsOpen: (isOpen: boolean) => void;
  mstRemarksKbValue: string;
  onCallbackFunction: (item: MstRemarks) => void;
}) => {
  const header = ['備考コード', '備考区分', '内容'];
  const [mstRemarks, setMstRemarks] = useState<Array<MstRemarks>>([]);
  const [mstRemarksCd, setMstRemarksCd] = useState<string>('');
  const [mstRemarksKb, setMstRemarksKb] = useState<string>(mstRemarksKbValue || '');

  const [searchMstRemarks, { data: mstRemarksData, loading: isMstRemarksLoading }] = useAppLazyQuery({
    query: gql(getMstRemarks),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onClickItemRemarks = (remarks: MstRemarks) => {
    onCallbackFunction(remarks);
    setIsOpen(false);
  };

  const renderTableData = useMemo(() => {
    if (mstRemarks?.length <= 0 || !mstRemarks) return;
    return mstRemarks.map((remarks: MstRemarks, index: number) => {
      const valueIndexOptions = parseInt(remarks?.mrm_remarks_kb) - 1;
      return (
        <tr onClick={() => onClickItemRemarks(remarks)} key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{remarks?.mrm_remarks_cd}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] cursor-pointer">
            <p>{remarksOptions[valueIndexOptions]?.label || ''}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p>{remarks?.mrm_remarks}</p>
          </td>
        </tr>
      );
    });
  }, [mstRemarks]);

  const searchMarks = () => {
    const params = {
      mrm_remarks_cd: mstRemarksCd === '' ? null : mstRemarksCd,
      mrm_remarks_kb: parseInt(mstRemarksKb) === 0 ? null : parseInt(mstRemarksKb),
    };
    searchMstRemarks({ variables: { input: params } });
  };

  const onPressSearch = () => {
    searchMarks();
  };

  useEffect(() => {
    const newMstRemarksData = { ...mstRemarksData };
    const listRemarks: MstRemarks[] =
      newMstRemarksData?.getMstRemarks?.sort((remark1: any, remark2: any) => {
        return remark1.mrm_remarks_cd - remark2.mrm_remarks_cd;
      }) || [];
    setMstRemarks(listRemarks);
  }, [mstRemarksData]);

  useEffect(() => {
    searchMarks();
  }, []);

  return (
    <>
      <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
      <div className="flex fixed bg-white h-4/6 w-1/3 items-center flex-col z-[1] overflow-auto">
        <div className="w-5/6 flex justify-end items-center mt-[10px]">
          <button onClick={() => setIsOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[50px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">備考コード</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full"
              onChange={(event) => {
                if (event.target.value.length > 8) return;
                setMstRemarksCd(event?.target?.value);
              }}
              type="number"
              name="mst_remarks_cd"
              value={mstRemarksCd}
              min={1}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">備考区分</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <select
              className={'bg-[#C0C0C0] pl-[5px] h-[40px] w-full '}
              name="mh_remarks_kb"
              onChange={(event) => {
                setMstRemarksKb(event?.target?.value);
              }}
              disabled
              defaultValue={mstRemarksKb}
            >
              <option value={0}></option>
              {remarksOptions?.map((itemOption) => {
                return (
                  <option key={`${itemOption?.value}`} value={`${itemOption?.value}`}>
                    {itemOption?.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="h-[40px] w-4/5	flex justify-end items-center mt-[10px] ">
          <button
            onClick={onPressSearch}
            className="border border-zinc-300 h-[40px] w-[100px] justify-center items-center flex"
          >
            <p>検索</p>
          </button>
        </div>
        <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
          <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]  ">
            <thead>
              <tr>{renderTableHeader()}</tr>
            </thead>
            <tbody>
              {isMstRemarksLoading ? (
                <tr>
                  <td
                    colSpan={header.length}
                    className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : (
                renderTableData
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ModalGuideRemarks;
